const RANDOM_COLOR = {

  methods: {

    /**
         * Method for generate dark color
         */
    generateColor () {
      const lum = -0.5;
      let rgb = '#';
      let parseHex;

      let hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      for (let i = 0; i < 3; i++) {
        parseHex = parseInt(hex.substr(i * 2, 2), 16);
        parseHex = Math.round(Math.min(Math.max(0, parseHex + (parseHex * lum)), 255)).toString(16);
        rgb += ('00' + parseHex).substr(parseHex.length);
      }
      return rgb;
    },

  },

};

export default RANDOM_COLOR;
